export default __webpack_public_path__ + "static/media/arm-left-back.938c7bdf.png";